/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M11 8.312v3.138c0 .204.08.399.225.543l1.695 1.695M1.4 6.008V5.24A3.84 3.84 0 015.24 1.4h.768m9.984 0h.768a3.84 3.84 0 013.84 3.84v.768M4.856 17.912L2.168 20.6m17.664 0l-2.688-2.688m2.304-6.144a8.448 8.448 0 11-16.896 0 8.448 8.448 0 0116.896 0z" _stroke="#5B6881" stroke-width="2" stroke-linecap="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/email.js